import Vue from 'vue'
import Router from 'vue-router'
import { DOCUMENT_TITLE_PREFIX } from '@/libs/constants'
import store from '@/store'

import Member from '@/views/member'
import Journey from '@/views/member/journey'
import Ranking from '@/views/member/ranking'
import Trend from '@/views/member/trend'
import Mine from '@/views/member/mine'
import Group from '@/views/member/group'
import Dashboard from '@/views/member/dashboard'
import AddDomain from '@/views/member/dashboard/Add'
import UserResearch from '@/views/member/user-research'
import Survey from '@/views/member/user-research/Survey'
import AddSurvey from '@/views/member/user-research/AddSurvey'

import UserInfo from '@/views/member/user-info'
import ManagePlan from '@/views/member/user-info/ManagePlan'
import MyInformation from '@/views/member/user-info/MyInformation'
import DeactivateComplete from '@/views/member/user-info/DeactivateComplete'
import Billing from '@/views/member/user-info/Billing'
import Jam from '@/views/member/user-info/Jam'
import Referrals from '@/views/member/user-info/Referrals'
import IpBlocking from '@/views/member/user-info/IpBlocking'

import HealthCheck from '@/views/HealthCheck'

import HeatmapOnly from '@/components/journey/heatmap/HeatmapOnly.vue'

import PageNotFound from '@/views/PageNotFound'

import { getI18n } from '@/libs/i18n'

Vue.use(Router)

const Sitemap = () => import('@/views/member/sitemap')

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'dashboard'
      }
    },
    {
      path: '/healthcheck',
      name: 'healthcheck',
      component: HealthCheck,
      meta: {
        layout: 'no-header',
        guestOnly: true
      }
    },
    {
      path: '/deactivate',
      name: 'deactivate',
      component: DeactivateComplete,
      meta: {
        layout: 'no-header',
        guestOnly: true
      }
    },
    {
      path: '/tool/journey',
      component: Journey,
      name: 'journey',
      meta: {
        layout: 'journey',
        title: 'Journey',
        forAll: true
      }
    },
    {
      path: '/tool/ranking',
      component: Ranking,
      name: 'ranking',
      meta: {
        layout: 'journey',
        title: 'Ranking',
        forAll: true
      }
    },
    {
      path: '/tool/sitemap',
      component: Sitemap,
      name: 'sitemap',
      meta: {
        layout: 'journey',
        title: 'Sitemap',
        adminOnly: true
      }
    },
    {
      path: '/tool/trend',
      component: Trend,
      name: 'trend',
      meta: {
        layout: 'journey',
        title: 'Trend',
        forAll: true
      }
    },
    {
      path: '/tool/mine',
      component: Mine,
      name: 'mine',
      meta: {
        layout: 'journey',
        title: 'Mine',
        forAll: true
      }
    },
    {
      path: '/member',
      name: 'member',
      redirect: {
        name: 'dashboard'
      },
      component: Member,
      children: [
        {
          path: '/tool',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            layout: 'dashboard',
            title: 'Dashboard'
          }
        },
        {
          path: '/tool/add',
          name: 'add',
          component: AddDomain,
          meta: {
            layout: 'dashboard',
            title: 'Domain Registration'
          }
        },
        {
          path: '/tool/edit',
          name: 'edit',
          component: AddDomain,
          meta: {
            layout: 'dashboard',
            title: 'Domain Registration'
          }
        },
        {
          path: '/tool/research',
          name: 'userResearch',
          component: UserResearch,
          meta: {
            layout: 'dashboard',
            title: 'User Research - Survey'
          }
        },
        {
          path: '/tool/survey',
          name: 'survey',
          component: Survey,
          meta: {
            layout: 'dashboard',
            title: 'User Research - Survey'
          }
        },
        {
          path: '/tool/survey/add',
          name: 'addSurvey',
          component: AddSurvey,
          meta: {
            layout: 'dashboard',
            title: 'User Research - Survey'
          }
        },
        {
          path: '/tool/user',
          name: 'userInfo',
          component: UserInfo,
          meta: {
            layout: 'userinfo'
          },
          children: [
            {
              path: 'manageplan',
              name: 'managePlan',
              component: ManagePlan,
              meta: {
                requireMyInfoAuth: true,
                title: 'Manage Plan'
              }
            },
            {
              path: 'myinformation',
              name: 'myInformation',
              component: MyInformation,
              meta: {
                requireMyInfoAuth: true,
                title: 'Info'
              }
            },
            {
              path: 'jam',
              name: 'jam',
              component: Jam,
              meta: {
                requireMyInfoAuth: true,
                title: 'Jam'
              }
            },
            {
              path: 'billing',
              name: 'billing',
              component: Billing,
              meta: {
                requireMyInfoAuth: true,
                title: 'Billing'
              }
            },
            {
              path: 'referrals',
              name: 'referrals',
              component: Referrals,
              meta: {
                requireMyInfoAuth: true,
                title: 'Referrals'
              }
            },
            {
              path: 'ipblocking',
              name: 'ipBlocking',
              component: IpBlocking,
              meta: {
                title: 'IP Blocking'
              }
            }
          ]
        },
        {
          path: '/tool/group',
          component: Group,
          name: 'group',
          meta: {
            layout: 'group',
            title: 'Group'
          }
        }
      ]
    },
    {
      path: '/heatmap/:aid([a-f\\d]+)',
      component: HeatmapOnly,
      name: 'heatmap-only',
      meta: {
        layout: 'empty',
        title: ''
      }
    },
    {
      path: '*',
      component: PageNotFound,
      meta: {
        forAll: true
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(route => route.meta.adminOnly)) {
    try {
      const userData = store.state.userData || await store.dispatch('storeUserData', { allowNoAuth: true })

      if (!userData || userData.userId !== 'admin') {
        return next({ name: 'dashboard', replace: true })
      }
    } catch (error) {
      return next({ name: 'dashboard', replace: true })
    }
  }

  let title
  const i18n = getI18n()
  const titleList = to.matched
    .map(item => item.meta.title)
    .filter(item => item !== undefined)
    .reverse()

  let pageTitle

  if (titleList.length) {
    pageTitle = titleList[0]
  }

  if (pageTitle !== null) {
    if (pageTitle) {
      title = i18n.t(`documentTitle.${pageTitle}`) + ` | ${DOCUMENT_TITLE_PREFIX}`
    }
    document.title = title
  }
  next()
})

export default router
